/* @flow */
import {
  FETCH,
  SAVE,
  EDIT,
  DELETE,
} from './action-types.js';

export const fetch = () => ({
  type: FETCH
});

export const saveSharingGroup = (sharingGroup: Object) => ({
  type: SAVE,
  payload: sharingGroup,
});

export const editSharingGroup = (sharingGroup: Object) => ({
  type: EDIT,
  payload: sharingGroup,
});

export const deleteSharingGroup = (id: string) => ({
  type: DELETE,
  payload: id,
});



// WEBPACK FOOTER //
// ./src/app/modules/groups/actions.js